// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ImgBitmap__image___29vcf{position:absolute!important}.ImgBitmap__image___29vcf{margin:auto;-webkit-user-select:none;-moz-user-select:none;-o-user-select:none;user-select:none}", ""]);
// Exports
exports.locals = {
	"image": "ImgBitmap__image___29vcf"
};
module.exports = exports;
